import { Component } from '@angular/core';

@Component({
  selector: 'app-te-role-task',
  templateUrl: './te-role-task.component.html',
  styleUrls: ['./te-role-task.component.css']
})
export class TeRoleTaskComponent {

}
